@if (environmentName !== 'PROD') {
  <span class="env-badge" [class]="'env-' + environmentName.toLowerCase()">
    {{ environmentName }}
  </span>
}
